import { VEHICLE_REGISTRATION_METHOD } from "@shared/constants";
import { useIsKeyAccount } from "@redux/reducers/auth";
import { useGetJourneySpecificConfig } from "@hooks/useGetJourneySpecificConfig";
import { useRegistrationCountryFilter } from "@hooks/useRegistrationCountryFilter";
import { computeAvailableRegistrationMethods } from "@lib/computeAvailableRegistrationMethods";

export const useCanCitroenHandleRegistrationPostalCode = () => {
  const journeyConfig = useGetJourneySpecificConfig();
  const isKeyAccount = useIsKeyAccount();
  const buildCountryFilter = useRegistrationCountryFilter();

  return (postalCode, country) => {
    const methods = computeAvailableRegistrationMethods(
      journeyConfig?.vehicleRegistration,
      postalCode,
      { isKeyAccount, ...buildCountryFilter(country) }
    );
    return methods.some(m => m.method === VEHICLE_REGISTRATION_METHOD.CITROEN);
  };
};
